import type from "./type";

export default type("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
});



//////////////////
// WEBPACK FOOTER
// ./~/d3-request/src/json.js
// module id = 1048
// module chunks = 0